import axios from '../utils/axios';
import { buildQuery } from '../admin/api';

const CARD_REDEMPTION_ROOT = '/card_redemption';

export async function fetchCardRedemptionOrders(params) {
  const response = await axios.get(`${CARD_REDEMPTION_ROOT}${buildQuery(params)}`);
  return response.data;
}

export async function findCardRedemptionOrder(query) {
  const response = await axios.get(`${CARD_REDEMPTION_ROOT}/find${buildQuery({ query })}`);
  return response.data;
}

export async function fetchCardRedemptionOrderDetails(orderId) {
  const response = await axios.get(`${CARD_REDEMPTION_ROOT}/details${buildQuery({ order_id: orderId })}`);
  return response.data;
}

export async function claimCardRedemptionOrder(payload) {
  const response = await axios.post(`${CARD_REDEMPTION_ROOT}/claim`, payload);
  return response.data;
}

export async function rejectCardRedemptionOrder(payload) {
  const response = await axios.post(`${CARD_REDEMPTION_ROOT}/reject`, payload);
  return response.data;
}

export async function disputeCardRedemptionOrder(payload) {
  const response = await axios.post(`${CARD_REDEMPTION_ROOT}/dispute`, payload);
  return response.data;
}

export async function completeCardRedemptionOrder(formData) {
  const response = await axios.post(`${CARD_REDEMPTION_ROOT}/complete`, formData);
  return response.data;
}

export async function submitCardRateEnquiry(payload) {
  const response = await axios.post(`${CARD_REDEMPTION_ROOT}/enquiry`, payload);
  return response.data;
}

export async function pollCardRateEnquiry(enquiryId) {
  const response = await axios.get(`${CARD_REDEMPTION_ROOT}/enquiry/${enquiryId}`);
  return response.data;
}

export async function fetchCardRedemptionCategories() {
  const response = await axios.get(`${CARD_REDEMPTION_ROOT}/categories`);
  return response.data;
}

export async function fetchCardRedemptionCurrencies() {
  const response = await axios.get(`${CARD_REDEMPTION_ROOT}/currencies`);
  return response.data;
}

export async function fetchCardRedemptionTypes() {
  const response = await axios.get(`${CARD_REDEMPTION_ROOT}/types`);
  return response.data;
}
